var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.9 15a1 1 0 0 1-.71-.29l-3.9-3.9a1 1 0 0 1 1.42-1.42l3.19 3.2 7.4-7.3a1 1 0 0 1 1.4 1.42l-8.1 8a1 1 0 0 1-.7.29z"
})));
export default SvgCheck;